import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ORDERS_TAB, USERS_TAB, SALES_DOCS_TAB, SALES_ARCHIVE_TAB, ADMINISTRATION_TAB } from '../constant';
import MainPageContent from './MainPageContentNew';
import OrdersTab from './OrdersTab';
import SalesDocsTab from './SalesDocsTab';
import SalesArchiveTab from './SalesArchiveTab';

const SALES_SUBTABS = [
    {
        key: ORDERS_TAB,
        title: 'Заказы клиентов',
        path: 'orders',
    },
    {
        key: SALES_DOCS_TAB,
        title: 'Документы продажи',
        path: 'docs',
    },
    {
        key: SALES_ARCHIVE_TAB,
        title: 'Архив',
        path: 'archive',
    },
    {
        key: USERS_TAB,
        title: 'Контрагенты',
        path: 'users',
    },
    {
        key: ADMINISTRATION_TAB,
        title: 'Администрация',
        path: 'administration',
    },
];

const SalesTab = ({ isCollapsed }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const activeKey = (() => {
        if (location.pathname.includes(SALES_ARCHIVE_TAB)) return SALES_ARCHIVE_TAB;
        if (location.pathname.includes(SALES_DOCS_TAB)) return SALES_DOCS_TAB;
        if (location.pathname.includes(ORDERS_TAB)) return ORDERS_TAB;
        if (location.pathname.includes(ADMINISTRATION_TAB)) return ADMINISTRATION_TAB;
        if (location.pathname.includes(USERS_TAB)) return USERS_TAB;
        return ORDERS_TAB;
    })();

    const orderJumpId = new URLSearchParams(location.search).get('orderId');
    const showOrderJump = Boolean(orderJumpId) && location.pathname.endsWith('/orders');

    const handleChange = (path) => {
        navigate(`/sales/${path}`);
    };

    return (
        <div className={`sales${showOrderJump ? ' sales--order-jump' : ''}`}>
            {showOrderJump ? (
                <div className="sales-order-jump" aria-hidden="true">
                    <div className="sales-order-jump__spinner" />
                </div>
            ) : null}
            <div className="sales-tabs__list">
                {SALES_SUBTABS.map((tab) => {
                    const isActive = activeKey === tab.key;
                    return (
                        <button
                            key={tab.key}
                            className={`sales-tabs__button${isActive ? ' sales-tabs__button--active' : ''}`}
                            onClick={() => handleChange(tab.path)}
                        >
                            {tab.title}
                        </button>
                    );
                })}
            </div>

            <Routes>
                <Route exact path="orders" element={<OrdersTab isCollapsed={isCollapsed} />} />
                <Route exact path="docs" element={<SalesDocsTab isCollapsed={isCollapsed} />} />
                <Route exact path="archive" element={<SalesArchiveTab isCollapsed={isCollapsed} />} />
                <Route exact path="users" element={<MainPageContent isCollapsed={isCollapsed} />} />
                <Route exact path="administration" element={<MainPageContent isCollapsed={isCollapsed} mode="administration" />} />
                <Route path="*" element={<Navigate to="orders" replace />} />
            </Routes>
        </div>
    );
};

export default SalesTab;
